import { requestJson } from "@unizpay/ui";
import type { CheckoutMethod, CheckoutSession, IssuedAddress } from "./types";

/** Public API origin; empty in development, where Vite proxies /v1 to wrangler dev. */
const API_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");
const enc = encodeURIComponent;

/**
 * The payment page is a client of the public API: the same /v1/payments endpoints a merchant
 * uses, authenticated with the payment's checkout token (`cs`) from the URL fragment.
 */
export const checkoutApi = {
  payment: (id: string, cs: string) =>
    requestJson<CheckoutSession>("GET", `${API_URL}/v1/payments/${enc(id)}`, { bearer: cs }),
  methods: (id: string, cs: string) =>
    requestJson<{ data: CheckoutMethod[] }>("GET", `${API_URL}/v1/payments/${enc(id)}/methods`, {
      bearer: cs,
    }),
  issueAddress: (id: string, cs: string, token: string, network: string) =>
    requestJson<IssuedAddress>("POST", `${API_URL}/v1/payments/${enc(id)}/address`, {
      body: { token, network },
      bearer: cs,
    }),
};
